/* Picobellonails header: megamenu op aanraakschermen + mobiel menu met schuifpanelen. */
(function () {
  if (window.pbHeaderReady) return;
  window.pbHeaderReady = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const canHover = window.matchMedia('(hover: hover)');

  /* ---------- Desktop: dropdowns ---------- */
  function setupDesktopNav(root) {
    const items = root.querySelectorAll('[data-pb-nav-item]');
    const closeAll = (except) => {
      items.forEach((item) => {
        if (item === except) return;
        item.classList.remove('is-open');
        item.querySelector('.pb-nav__link')?.setAttribute('aria-expanded', 'false');
      });
    };

    items.forEach((item) => {
      const link = item.querySelector('.pb-nav__link');
      item.addEventListener('mouseenter', () => {
        item.classList.remove('is-closed');
        link.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('mouseleave', () => {
        item.classList.remove('is-closed', 'is-open');
        link.setAttribute('aria-expanded', 'false');
      });
      // Op een aanraakscherm opent de eerste tik het menu, de tweede volgt de link.
      link.addEventListener('click', (event) => {
        if (canHover.matches) return;
        if (!item.classList.contains('is-open')) {
          event.preventDefault();
          closeAll(item);
          item.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      items.forEach((item) => {
        if (item.contains(document.activeElement) || item.classList.contains('is-open')) {
          item.classList.remove('is-open');
          item.classList.add('is-closed');
          const link = item.querySelector('.pb-nav__link');
          link.setAttribute('aria-expanded', 'false');
          link.focus();
        }
      });
    });
    root.addEventListener('focusin', (event) => {
      items.forEach((item) => {
        if (!item.contains(event.target)) item.classList.remove('is-closed');
      });
    });
    document.addEventListener('click', (event) => {
      if (!root.contains(event.target)) closeAll();
    });
  }

  /* ---------- Mobiel menu ---------- */
  function setupMobileMenu() {
    const menu = document.getElementById('PbMobileMenu');
    if (!menu) return;
    const openers = document.querySelectorAll('[data-pb-menu-open]');
    let lastOpener = null;

    const showPanel = (id, back) => {
      const target = menu.querySelector('#' + CSS.escape(id));
      if (!target) return;
      menu.querySelectorAll('[data-pb-panel]').forEach((panel) => {
        panel.hidden = panel !== target;
      });
      target.scrollTop = 0;
      if (!reduceMotion) {
        const cls = back ? 'is-entering-back' : 'is-entering';
        target.classList.add(cls);
        requestAnimationFrame(() => requestAnimationFrame(() => target.classList.remove(cls)));
      }
      const focusable = target.querySelector('button, a, input');
      focusable?.focus({ preventScroll: true });
    };

    const open = (opener) => {
      lastOpener = opener;
      showPanel('PbPanel-root', false);
      menu.hidden = false;
      document.body.classList.add('pb-menu-open');
      openers.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
    };
    const close = () => {
      menu.hidden = true;
      document.body.classList.remove('pb-menu-open');
      openers.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
      lastOpener?.focus();
    };

    openers.forEach((btn) => btn.addEventListener('click', () => open(btn)));
    menu.addEventListener('click', (event) => {
      const go = event.target.closest('[data-pb-go]');
      if (go) {
        showPanel(go.dataset.pbGo, go.hasAttribute('data-pb-back'));
        return;
      }
      if (event.target.closest('[data-pb-menu-close]')) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !menu.hidden) close();
    });
    window.matchMedia('(min-width: 1100px)').addEventListener('change', (mq) => {
      if (mq.matches && !menu.hidden) close();
    });
  }

  /* Hoogte van de vaste header als CSS-variabele (voor andere vaste balken). */
  function trackHeaderHeight() {
    const section = document.querySelector('.section-pb-header');
    if (!section) return;
    const set = () => document.documentElement.style.setProperty('--pb-header-h', section.offsetHeight + 'px');
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(section);
  }

  /* Winkelmand-lade: upsells toevoegen en door de rij schuiven */
  document.addEventListener('click', async (event) => {
    const scrollBtn = event.target.closest('[data-pb-upsell-scroll]');
    if (scrollBtn) {
      const rail = scrollBtn.closest('.pb-upsells')?.querySelector('.pb-upsells__rail');
      if (rail) rail.scrollBy({ left: Number(scrollBtn.dataset.pbUpsellScroll) * rail.clientWidth * 0.85, behavior: 'smooth' });
      return;
    }
    const addBtn = event.target.closest('[data-pb-upsell-add]');
    if (!addBtn || addBtn.disabled) return;
    const drawer = document.querySelector('cart-drawer');
    addBtn.disabled = true;
    addBtn.classList.add('is-loading');
    try {
      const res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(addBtn.dataset.pbUpsellAdd), quantity: 1 }],
          sections: drawer ? drawer.getSectionsToRender().map((s) => s.id) : [],
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description);
      if (drawer) drawer.renderContents(data);
      else window.location = window.routes.cart_url;
    } catch (e) {
      addBtn.textContent = 'Niet gelukt';
      addBtn.disabled = false;
      addBtn.classList.remove('is-loading');
    }
  });

  /* Foto's verderop alvast op de achtergrond laden zodra de pagina klaar is,
     zodat ze er al staan als je scrolt (vooral Safari laadt ze anders pas laat). */
  function preloadLazyImages() {
    const noHover = !canHover.matches;
    const queue = [...document.querySelectorAll('img[loading="lazy"]')].filter((img) => {
      if (img.closest('.section-pb-header, #PbMobileMenu, cart-drawer')) return false;
      if (noHover && img.classList.contains('pb-card__img--hover')) return false;
      return true;
    });
    const step = () => {
      queue.splice(0, 6).forEach((img) => { img.loading = 'eager'; });
      if (queue.length) setTimeout(step, 150);
    };
    step();
  }
  function whenIdle(fn) {
    const run = () => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 1500 }) : setTimeout(fn, 300));
    if (document.readyState === 'complete') run();
    else window.addEventListener('load', run, { once: true });
  }

  function init() {
    whenIdle(preloadLazyImages);
    document.querySelectorAll('pb-header').forEach(setupDesktopNav);
    setupMobileMenu();
    trackHeaderHeight();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
